import menuUtama from './menu-utama';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [menuUtama]
};

export default menuItems;
